// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1F1XR","label":"Section_label__2EU7T","contentWrap":"Section_contentWrap__1va2K","footer":"Section_footer__3aNb7","footerInner":"Section_footerInner__1K8E4"};